import axios from 'axios'
import { getStore } from '/utils/storage.js'
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'
axios.defaults.headers.post['x-Token'] = getStore('token')

axios.interceptors.request.use(config => {
  config.headers['x-Token'] = getStore('token')
  return config
}, error => {
  return Promise.reject(error)
})

export default {
  fetchGet (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPost (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/public.js